import React from 'react';
import classNames from 'classnames';

function ContentTypeIcon({ className, icon, iconClassName, name }) {
    if (iconClassName)
        return React.createElement("i", { className: classNames(className, 'bc-icon', `bc-${iconClassName}`), role: 'img' });
    return React.createElement("img", { src: icon, alt: name, className: className });
}

export { ContentTypeIcon };
